import { Tickets4Basket } from 'components'
import messages from 'i18n/messages'
import { drawSeatingPlan } from 'lib/spl/draw'
import flowRight from 'lodash/flowRight'
import { checkMaxQty, claimSeatsGetOrder, clearCandidates, toggleCandidate } from 'logic/orders'
// import { fetchSeatById } from 'logic/seats'
import { makeSelectPcts } from 'logic/pcts'
import { makeSelectSeatingPlanById } from 'logic/spl'
import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Tooltip } from 'react-tippy'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'

class SeatingPlan extends Component {

  componentDidUpdate() {
    const updateStyles = require('lib/spl/utils').updateStyles
    if (this.props.pcts) updateStyles(this.props.pcts)
    if (this.svgDrawn) return

    drawSeatingPlan(
      this.refs.canvas,
      this.props.spl.svg_data,
      this.props.spl.width,
      this.props.spl.height,
      this.props.actions,
      this.props.admin
    );
    this.svgDrawn = true
  }

  render() {
    const { intl: { formatMessage } } = this.props

    return (
      <div className="spl-container">
        <div className="zoom-btns">
          <Tooltip title={formatMessage(messages.zoomIn)}>
            <div className="zoom-in"><i className="tt-icon tt-icon-e-add" /></div>
          </Tooltip>
          <Tooltip title={formatMessage(messages.resetZoom)}>
            <div className="zoom-reset"><i className="tt-icon tt-icon-screen-enlarge" /></div>
          </Tooltip>
          <Tooltip title={formatMessage(messages.zoomOut)}>
            <div className="zoom-out" ref={this.zoomOut}><i className="tt-icon tt-icon-i-delete" /></div>
          </Tooltip>
        </div>
        <div className="seating-plan-frame">
          <div className="seating-plan-wrap">
            <svg className="seating-plan-canvas pub-frame" ref="canvas" />
          </div>
          <Tickets4Basket />
        </div>
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  spl: makeSelectSeatingPlanById(props => props.splId),
  pcts: makeSelectPcts(),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    checkMaxQty,
    claimSeatsGetOrder,
    toggleCandidate,
    // fetchSeatById,
    clearCandidates,
  }, dispatch)
});

const enhance = flowRight(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(SeatingPlan)
